const commentsData = [
  {
    name: '影迷小陈',
    time: '3天前',
    content: '在91电影视频追完了《漫长的季节》，画质真的没得说，1080P丝滑流畅。而且居然真的没有广告！已经推荐给身边所有喜欢国产剧的朋友了。',
    tag: '悬疑剧爱好者',
  },
  {
    name: '电影老炮儿',
    time: '5天前',
    content: '作为一个看了二十年国产电影的老影迷，91电影视频的片库真的让我惊喜。很多冷门佳作在这里都能找到，更新速度也很快，新片上线基本同步。',
    tag: '资深影迷',
  },
  {
    name: '追剧小仙女',
    time: '1周前',
    content: '全网找《狂飙》高清资源找了很久，终于在这里看到了！全集免费高清，手机上看也不卡，午休时间追一集刚刚好。国产剧爱好者必收藏的平台。',
    tag: '剧集达人',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实观众的使用反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.name}
              className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-700 font-bold text-sm">
                  {comment.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs text-accent-600 bg-accent-100/60 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}